import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import BrandingProvider from "@/contexts/BrandingProvider";
import BrowserIdentity from "@/contexts/BrowserIdentity";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";

// Pages
import Homepage from "@/pages/Homepage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import EntryManagement from "@/pages/EntryManagement";
import PrizeManagement from "@/pages/PrizeManagement";
import DrawControl from "@/pages/DrawControl";
import WinnerHistory from "@/pages/WinnerHistory";
import EventSettings from "@/pages/EventSettings";
import ContentManagement from "@/pages/ContentManagement";
import LiveDraw from "@/pages/LiveDraw";

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <BrowserIdentity />
        <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/live-draw" element={
              <ProtectedRoute>
                <LiveDraw />
              </ProtectedRoute>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/entries"
              element={
                <ProtectedRoute>
                  <EntryManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/prizes"
              element={
                <ProtectedRoute>
                  <PrizeManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/draw"
              element={
                <ProtectedRoute>
                  <DrawControl />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/winners"
              element={
                <ProtectedRoute>
                  <WinnerHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <EventSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/content"
              element={
                <ProtectedRoute>
                  <ContentManagement />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#121212',
              color: '#FFFFFF',
              border: '1px solid rgba(212, 175, 55, 0.2)',
            },
          }}
        />
        </div>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;
